export default __webpack_public_path__ + "static/media/sb-img.05360191.webp";